import { RootState } from '../../index'
import { Alert } from '../../../types/alert'
import { createSelector } from 'reselect'
import dayjs from 'dayjs'

export const selectRealtimeAlerts = (state: RootState): Array<Alert> =>
	state.appReducer?.realtimeAlerts?.list || []

export const selectCountOfRealtimeAlerts = (state: RootState): number =>
	state.appReducer?.realtimeAlerts?.list?.length || 0

export const selectMembersNeedAttention = (state: RootState): number => {
	const realtimeAlerts = state.appReducer?.realtimeAlerts?.list || []

	const reducedByPatients = realtimeAlerts.reduce((r, alert) => {
		r[alert.patientData.ID] = r[alert.patientData.ID] || []

		r[alert.patientData.ID].push(alert)

		return r
	}, Object(null))

	return Object.entries(reducedByPatients).length
}

export const selectSortedByTimeRealtimeAlerts = createSelector(
	selectRealtimeAlerts,
	(realtimeAlerts): Array<Alert> =>
		[...realtimeAlerts].sort(
			(a, b) =>
				dayjs(b.op.addedTimestamp).valueOf() -
				dayjs(a.op.addedTimestamp).valueOf()
		)
)
